/* External */
import {
  memo,
  createContext,
  useReducer,
  useContext,
  useMemo,
} from 'react';
import PropTypes from 'prop-types';

/* Utils */
import { reducer, initialState } from './loadingStore';

// TODO Review this approach, if it needs to be integrated with the
// current redux store.
export const LoadingStoreContext = createContext(undefined);

function LoadingProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  /* Stable value identity: the raw useReducer tuple is a fresh array on
     every provider render, which re-rendered every consumer (the whole
     routed page) on unrelated parent renders. */
  const value = useMemo(() => [state, dispatch], [state, dispatch]);

  return (
    <LoadingStoreContext.Provider value={value}>
      {children}
    </LoadingStoreContext.Provider>
  );
}

LoadingProvider.propTypes = {
  children: PropTypes.node,
};

export const useStore = () => useContext(LoadingStoreContext);
export default memo(LoadingProvider);
